import { createSelector } from "../helper";

export const getFoldersObject = (state) => state.bookmarks.folders;

export const isFoldersFetched = createSelector(getFoldersObject, (folders) => folders.isFetched);

export const areFoldersLoading = createSelector(getFoldersObject, (folders) => folders.isLoading);

export const selectFolders = createSelector(getFoldersObject, (folders) => folders.data);
